import { observable, action } from 'mobx'
class ColumnState {
  @observable public homeColumnType = ''

  @action
  public updateColumn = (value: any) => {
    this.homeColumnType = value
  }
}
export default new ColumnState()

// const ColumnState = observable({
//   homeColumntype: ''
// });
// ColumnState.setColumn =
